// from general.js
/* global Handlebars isMobileView dcAnalytics isLoggedIn readCookie isEmailAddress submitFormToIframe updateFavoritesCookie getQueryStringParam */
import './followForm.tmpl.js';


// constants for Teacher Page
var FAVORITE_TEACHER_LINK_ON_VALUE = 'Following';
var FAVORITE_TEACHER_LINK_OFF_VALUE = 'Follow classroom for updates';

function prepareFollowForm() {
    if (!document.followEmailForm) {
        var templateV = Handlebars.templates['followForm.tmpl'];
        var htmlV = templateV({});
        $('body').prepend(htmlV);
        $('.js-follow-email-close').on('click', function (e) {
            document.getElementById('followEmail').style.display = 'none';
            e.preventDefault();
        });
        $('.js-follow-email-submit').on('click', setFollowSubmitStyles);
    }
}

function setFollowSubmitStyles() {
    document.getElementById('followEmail').style.display = 'none';
    // update the star as if it is already successful
    prepareFollowForm();
    try {
        if (document.followEmailForm.teacherId.value != '') {
            $('.favTeacherLink' + document.followEmailForm.teacherId.value).addClass('followStarLoading');
            if ($('.favTeacherLink' + document.followEmailForm.teacherId.value).hasClass('followStar')) {
                $('.favTeacherLink' + document.followEmailForm.teacherId.value).removeClass('followStar').addClass('followStarOn');
                $('.favTeacherLink' + document.followEmailForm.teacherId.value + '> .favorite-text').html(FAVORITE_TEACHER_LINK_ON_VALUE);
            } else {
                $('.favTeacherLink' + document.followEmailForm.teacherId.value).removeClass('followStarOn').addClass('followStar');
                $('.favTeacherLink' + document.followEmailForm.teacherId.value + '> .favorite-text').html(FAVORITE_TEACHER_LINK_OFF_VALUE);
            }
        } else if (document.followEmailForm.schoolId.value != '') {
            $('.favSchoolLink').addClass('followStarLoading');
            if ($('.favSchoolLink').hasClass('followStar')) $('.favSchoolLink').removeClass('followStar').addClass('followStarOn');
            else $('.favSchoolLink').removeClass('followStarOn').addClass('followStar');
        } else if (document.followEmailForm.challengeId.value != '') {
            $('.favChallengeLink').addClass('followStarLoading');
            if ($('.favChallengeLink').hasClass('followStar')) $('.favChallengeLink').removeClass('followStar').addClass('followStarOn');
            else $('.favChallengeLink').removeClass('followStarOn').addClass('followStar');
        } else if (document.followEmailForm.searchURL.value != '') {
            $('.favSearchLink').addClass('followStarLoading');
            if ($('.favSearchLink').hasClass('followStar')) $('.favSearchLink').removeClass('followStar').addClass('followStarOn');
            else $('.favSearchLink').removeClass('followStarOn').addClass('followStar');
        }
    } catch (e) {
        //
    }
}

// This is currently used from two other files
// Those files are teacherProfile.js and initFavorites.js.
export function addOrRemoveFavorite(id, favoriteType, linkId, labelText) {
    if ($('#' + linkId).hasClass('followStarLoading')) return;

    resetFollowForm(id, favoriteType, linkId, labelText);

    if (isMobileView() && pageName === 'school') {
        $('#donateBar').css({ position: 'relative' }).append($('#followEmailHolder'));
        $('#followEmailHolder').css({
            position: 'absolute',
            top: $('#donateBar').height() + 'px',
            width: '100%',
            left: '5px',
        });
    } else if (isMobileView()) {
        $('body').append($('#followEmailHolder'));
        $('#followEmailHolder').css({
            position: 'absolute',
            top: $('#' + linkId).offset().top + 55 + 'px',
            left: '0px',
        });
    } else {
        $('body').append($('#followEmailHolder'));
        $('#followEmailHolder').css({
            position: 'absolute',
            top: $('#' + linkId).offset().top + 55 + 'px',
            left: $('#' + linkId).offset().left + 'px',
        });
    }

    document.getElementById('followEmailHolder').style.display = '';
    followSearch();
}

function resetFollowForm(id, followType, linkId, labelText) {
    prepareFollowForm();
    document.followEmailForm.challengeId.value = '';
    document.followEmailForm.teacherId.value = '';
    document.followEmailForm.schoolId.value = '';
    document.followEmailForm.searchURL.value = '';
    document.followEmailForm.followAbout.value = '';
    document.followEmailForm.elements[followType].value = id;
    if ($('#' + linkId).hasClass('followStarOn')) {
        document.followEmailForm.remove.value = 'true';
        document.followEmailForm.followSubmit.value = 'Remove';
    } else {
        document.followEmailForm.remove.value = 'false';
        document.followEmailForm.followSubmit.value = 'Go';
    }
    if (labelText != null) document.followEmailForm.followAbout.value = labelText;
    if (document.followEmailForm.remove.value == 'true') {
        document.getElementById('followEmailMessage').innerHTML = "We'll remove " + document.followEmailForm.followAbout.value + ' from your Following.';
    } else {
        document.getElementById('followEmailMessage').innerHTML = 'Email address';
    }
}

function followSearch() {
    var trackAction = 'Follow';

    if (document.followEmailForm.teacherId.value != '') {
        trackAction += '-teacher';
    } else if (document.followEmailForm.schoolId.value != '') {
        trackAction += '-school';
    } else if (document.followEmailForm.challengeId.value != '') {
        trackAction += '-challenge';
    } else if (document.followEmailForm.searchURL.value != '') {
        if (document.followEmailForm.searchURL.value.indexOf('school=') > -1) {
            trackAction += '-school';
        } else {
            trackAction += '-search';
        }
    }

    if ($('#noProjects').length > 0) {
        trackAction += '-noresults';
    }
    dcAnalytics.trackEventGA([pageName, trackAction, 'Click']);

    if (document.getElementById('followIframe')) {
        var wiEl = document.getElementById('followIframe');
        wiEl.parentNode.removeChild(wiEl);
    }
    const followIframe = document.createElement('iframe');
    followIframe.setAttribute('id', 'followIframe');
    followIframe.setAttribute('name', 'followIframe');
    followIframe.setAttribute('width', '0');
    followIframe.setAttribute('height', '0');
    followIframe.setAttribute('frameBorder', '0');
    document.body.appendChild(followIframe);
    document.followEmailForm.target = 'followIframe';
    if (!isLoggedIn() && readCookie('userId') == null && !isEmailAddress(document.followEmailForm.email.value) &&
        location.search.indexOf('verify=') === -1) {
        document.getElementById('followEmail').style.display = 'block';
        document.getElementById('followEmailHolder').style.display = '';
        document.followEmailForm.email.disabled = false;
    } else {
        if (document.getElementById('followEmail').style.display == 'none') {
            document.followEmailForm.email.disabled = true;
        }
        submitFormToIframe(document.followEmailForm, 'followEmailFormIframe');
        setFollowSubmitStyles();
        $('#fav-teacher-link').blur();
    }
}

// This appears to be used as a callback when the form in followForm.tmpl is submitted
// eslint-disable-next-line no-unused-vars
window.followStatus = function (obj) {
    // Won't these typeof conditions always be truthy?
    if (typeof obj.data.teacherId) $('.favTeacherLink' + obj.data.teacherId).removeClass('followStarLoading');
    else if (typeof obj.data.schoolId) $('.favSchoolLink').removeClass('followStarLoading');
    else if (typeof obj.data.challengeId) $('.favChallengeLink').removeClass('followStarLoading');
    else if (typeof obj.data.searchURL) $('.favSearchLink').removeClass('followStarLoading');

    if (obj.data.success) {
        $('body').trigger('followStatusSuccess', obj.data);
        $('#favoriteSchool').hide();
        createCookie('followDate', (new Date()).getTime(), 0);

        if (!obj.data.remove) {
            // also set up toast message
            toast(obj.data.message);
        }
        try {
            document.getElementById('followSuggestionsHolder').style.height = 'auto';
            getFollowSuggestions(true);
        } catch (e) {}
        document.getElementById('followEmail').style.display = 'none';
        document.followEmailForm.email.disabled = true;
        dcAnalytics.trackEventGA([pageName, 'Follow', 'Success']);
    } else if (obj.data.signinRequired) {
        if (obj.data.message) document.getElementById('followEmailMessage').innerHTML = obj.data.message;
        document.getElementById('followEmail').style.display = 'block';
        document.followEmailForm.email.disabled = false;
    } else if (obj.data.emailRequired) {
        if (obj.data.message) document.getElementById('followEmailMessage').innerHTML = obj.data.message;
        document.getElementById('followEmail').style.display = 'block';
        document.followEmailForm.email.disabled = false;
        $('#schoolSubmit').show();
    } else {
        toast(obj.data.message);
        document.getElementById('followEmail').style.display = 'none';
        document.followEmailForm.email.disabled = true;
    }
    setUpUserCookies();
    showSignOutLink();
    addFavoritesToLocalStorage(obj);
}

// Set up favorites cookies
var favProposalIds = null;
var favTeacherIds = null;
var favSchoolIds = null;
var favChallengeIds = null;
var favSearchURLs = null;

function getFavorites(isSet) {
    favProposalIds = null;
    favTeacherIds = null;
    favSchoolIds = null;
    favChallengeIds = null;
    favSearchURLs = null;

    $.when(getFavList('favProposalIds'),
        getFavList('favTeacherIds'),
        getFavList('favSchoolIds'),
        getFavList('favChallengeIds'),
        getFavList('favSearchURLs')).then(function (favProposalIdsList, favTeacherIdsList, favSchoolIdsList, favChallengeIdsList, favSearchURLsList) {
        favProposalIds = favProposalIdsList;
        favTeacherIds = favTeacherIdsList;
        favSchoolIds = favSchoolIdsList;
        favChallengeIds = favChallengeIdsList;
        favSearchURLs = favSearchURLsList;
        resetFollowStars();
        $(document).trigger('favoritesVariablesAvailable');
    });
}

function resetFollowStars() {
    if (favProposalIds != null) {
        if (typeof proposalsOnPage !== 'undefined') {
            for (i in proposalsOnPage) {
                if (proposalsOnPage.hasOwnProperty(i)) {
                    if ($.inArray(parseInt(proposalsOnPage[i]), favProposalIds) > -1) {
                        $('.addToWishlistLink' + proposalsOnPage[i]).removeClass('followStar').addClass('followStarOn');
                    } else {
                        $('.addToWishlistLink' + proposalsOnPage[i]).removeClass('followStarOn').addClass('followStar');
                    }
                }
            }
        }
    }

    if (favTeacherIds != null) {
        if (typeof teachersOnPage !== 'undefined') {
            for (i in teachersOnPage) {
                if (teachersOnPage.hasOwnProperty(i)) {
                    if ($.inArray(parseInt(teachersOnPage[i]), favTeacherIds) > -1) {
                        $('.favTeacherLink' + teachersOnPage[i]).removeClass('followStar').addClass('followStarOn');
                    } else {
                        $('.favTeacherLink' + teachersOnPage[i]).removeClass('followStarOn').addClass('followStar');
                    }
                }
            }
        }
        // for teacher profile page
        if (typeof teacherId !== 'undefined') {
            if ($.inArray(parseInt(teacherId), favTeacherIds) > -1) {
                $('.favTeacherLink' + teacherId).addClass('saved');
                $('.favTeacherLink' + teacherId).removeClass('followStar').addClass('followStarOn');
                $('.favTeacherLink' + teacherId + '> .favorite-text').html(FAVORITE_TEACHER_LINK_ON_VALUE);
            } else {
                $('.favTeacherLink' + teacherId).removeClass('saved');
                $('.favTeacherLink' + teacherId).removeClass('followStarOn').addClass('followStar');
                $('.favTeacherLink' + teacherId + '> .favorite-text').html(FAVORITE_TEACHER_LINK_OFF_VALUE);
            }
        }
    }

    // do not rely on favDonorIds cookie since only 50 are listed

    if (favSchoolIds != null && typeof followSchoolId !== 'undefined') {
        if ($.inArray(parseInt(followSchoolId), favSchoolIds) > -1) {
            $('.favSchoolLink').removeClass('followStar').addClass('followStarOn');
        } else {
            $('.favSchoolLink').removeClass('followStarOn').addClass('followStar');
        }
    }

    if (favChallengeIds != null && typeof followChallengeId !== 'undefined') {
        if ($.inArray(parseInt(followChallengeId), favChallengeIds) > -1) {
            $('.favChallengeLink').removeClass('followStar').addClass('followStarOn');
        } else {
            $('.favChallengeLink').removeClass('followStarOn').addClass('followStar');
        }
    }

    if (favSearchURLs != null && $('#searchVOHashCode').text() != '') {
        var searchVOHashCode = $('#searchVOHashCode').text();
        var isFavorite = $.inArray(parseInt(searchVOHashCode), favSearchURLs) > -1;
        // Searches for specific schools are converted to school favs, so we have to check that as well.
        if (!isFavorite && favSchoolIds != null) {
            /* global searchURLString */ // This comes from the search controller
            var schoolId = getQueryStringParam(searchURLString, 'school');
            if (schoolId && schoolId.constructor === Array) {
                schoolId = schoolId[0];
            }
            isFavorite = schoolId != null && $.inArray(schoolId, favSchoolIds) > -1;
        }
        if (isFavorite) {
            $('.favSearchLink').removeClass('followStar').addClass('followStarOn');
            $('#favoriteSchool').hide();
        } else {
            $('.favSearchLink').removeClass('followStarOn').addClass('followStar');
        }
    }
}

// noinspection PointlessBooleanExpressionJS,JSObjectNullOrUndefined
if ((favSearchURLs != null && favSearchURLs.indexOf('search') > -1) || (readCookie('userId') != null && readCookie('userId') != '' && readCookie('favCookiesSet') == null)) {
    updateFavoritesCookie();
} else if (readCookie('favCookiesSet') != null) {
    $(document).ready(function () {
        getFavorites(true);
    });
}

$(document).on('updateFavoritesCookie', function () {
    getFavorites(true);
});

$(window).on('removeFavorites', function () {
    resetFollowStars();
});

$('body').bind('resetBigMarkerInfo', function () {
    if (document.getElementById('wishlist')) document.getElementById('wishlist').style.display = 'none';
    if (document.getElementById('wishlistHolder')) document.getElementById('wishlistHolder').style.display = 'none';
});
